import { render, staticRenderFns } from "./ApprovePpaAction.vue?vue&type=template&id=1fe2ee70&scoped=true"
import script from "./ApprovePpaAction.vue?vue&type=script&lang=js"
export * from "./ApprovePpaAction.vue?vue&type=script&lang=js"
import "./ApprovePpaAction.vue?vue&type=style&index=0&id=1fe2ee70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe2ee70",
  null
  
)

export default component.exports